import React, { useState, useEffect } from "react";
import axios from "axios";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import SyncAltOutlinedIcon from "@mui/icons-material/SyncAltOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import {
  showToast,
  WEBSERVICE,
  TRADESERVICE,
  handleGetAssetCode,
  handleGetAssetId,
  CACHESERVICE,
  checkCurrencyPairAccreditedStatus,
} from "../../CoreDataService";
import {
  Box,
  MenuItem,
  TextField,
  Typography,
  Tabs,
  Tab,
  Tooltip,
  InputAdornment,
  CircularProgress,
  alpha,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import sendIconCore from "../../Assets/Images/send.png";
import { useSelector } from "react-redux";
import { ContainedButton } from "../../Common/Buttons";
import FeeModal from "./FeeModal";
import AccreditationVerificationPopup from "../Accredited-Kyc/AccreditationVerificationPopup";
import TermsAgreementPopup from '../Accredited-Kyc/TermsAgreementPopup'

const ConvertComponent = () => {
  const navigate = useNavigate();
  const { btncolor } = useSelector((state) => state);
  const theme = localStorage.getItem("theme");

  const [counterCurrency, setCounterCurrency] = useState([]);
  const [baseCurrency, setBaseCurrency] = useState([]);
  const [selectedCounter, setSelectedCounter] = useState("");
  const [selectedBase, setSelectedBase] = useState("");
  const [onlyBuyAmount, setOnlyBuyAmount] = useState("");
  const [onlyBuyUSD, setOnlyBuyUSD] = useState("");
  const [onlyBuyPrice, setOnlyBuyPrice] = useState("");
  const [onlyBuyTotalPrice, setOnlyBuyTotalPrice] = useState("");
  const [onlySellAmount, setOnlySellAmount] = useState("");
  const [onlySellUSD, setOnlySellUSD] = useState("");
  const [onlySellPrice, setOnlySellPrice] = useState("");
  const [onlySellTotalPrice, setOnlySellTotalPrice] = useState("");
  const [fees, setFees] = useState(null);
  const [balances, setBalances] = useState({ sellingAsset: 0, buyingAsset: 0 });
  const [orderHistory, setOrderHistory] = useState([]);
  const [buttonType, setButtonType] = useState("Buy");
  const [buttonTypeSmall, setButtonTypeSmall] = useState("buy");
  const [accountType, setAccountType] = useState("Buying");
  const [balanceList, setBalanceList] = useState([]);
  const [currencyBalance, setCurrencyBalance] = useState([]);
  const [selectedCryptoCurrency, setSelectedCryptoCurrency] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedBuyingAssetBalance, setSelectedBuyingAssetBalance] = useState(0);
  const [selectedSellingAssetBalance, setSelectedSellingAssetBalance] = useState(0);
  const [actionType, setActionType] = useState(1);
  const [isBuySellEligible, setIsBuySellEligible] = useState(false);
  const [isBuyError, setIsBuyError] = useState(false);
  const [isBuyErrorDepth, setIsBuyErrorDepth] = useState(false);
  const [isBuyErrorSell, setIsBuyErrorSell] = useState(false);
  const [isSellErrorDepth, setIsSellErrorDepth] = useState(false);
  const [isSellError, setIsSellError] = useState(false);
  const [marketPrice, setMarketPrice] = useState("");
  const [buyingCryptoBalance, setBuyingCryptoBalance] = useState("");
  const [sellingCryptoBalance, setSellingCryptoBalance] = useState("");
  const [onlyBuyPrice1, setOnlyBuyPrice1] = useState(0);
  const [onlySellAmountState, setOnlySellAmountState] = useState("");
  const [onlySellPrice1, setOnlySellPrice1] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSellingAssetText, setSelectedSellingAssetText] = useState(
    localStorage.getItem("selling_crypto_asset") || "USDT"
  );
  const [swapBuy, setSwapBuy] = useState(false);
  const [swapSell, setSwapSell] = useState(false);
  const [baseUSDValue, setBaseUSDValue] = useState("");
  const [counterUSDValue, setCounterUSDValue] = useState("");
  const [showAccreditedPopup, setShowAccreditedPopup] = useState(false);
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [termsLinks, setTermsLinks] = useState([]);
  const [pendingProceed, setPendingProceed] = useState(null);
  const [pendingTxnType, setPendingTxnType] = useState(null);

  useEffect(() => {
    getBasecurrencyList();
    fetchBalances();
    fetchAssetsData();
  }, []);

  useEffect(() => {
    console.log("Reset state updated", { selectedSellingAssetBalance, selectedBuyingAssetBalance });
  }, [selectedSellingAssetBalance, selectedBuyingAssetBalance]);

  const fetchAssetsData = async () => {
    try {
      const response = await axios.get(
        `${CACHESERVICE}/getAssetsData?Name=Assets&BrokerId=${localStorage.getItem("BROKERID")}`
      );
      const parsedCurrencyData = JSON.parse(response.data.value);
      localStorage.setItem("spot_assets", JSON.stringify(parsedCurrencyData.Values));
    } catch (error) {
      console.error("Error fetching assets data:", error);
    }
  };

  const fetchBalances = async () => {
    const userTransObj = {
      customerId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
    };
    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      const result = response.data;
      setBalanceList(result.userBalanceList);
      setCurrencyBalance(result.userBalanceList);
      if (result.error.error_data != 0) {
        setErrorMessage("Cannot fetch user balance");
        showToast("error", "Cannot fetch user balance");
      } else {
        setSelectedCryptoCurrency(localStorage.getItem("selected_currency"));
        for (let i = 0; i < result.userBalanceList.length; i++) {
          const balance = result.userBalanceList[i];
          if (balance.currencyCode === localStorage.getItem("buying_crypto_asset").toUpperCase()) {
            setBuyingCryptoBalance(balance.closingBalance.toFixed(4));
          }
          if (balance.currencyCode === localStorage.getItem("selling_crypto_asset").toUpperCase()) {
            setSellingCryptoBalance(balance.closingBalance.toFixed(4));
          }
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        logout();
      } else if (
        error.response &&
        error.response.status !== 200 &&
        error.response.status !== 429 &&
        error.response.status !== 403
      ) {
        showToast("error", error.message);
      }
    }
  };

  const handleSwapBuy = () => setSwapBuy((prev) => !prev);
  const handleSwapSell = () => setSwapSell((prev) => !prev);

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  console.log("isBuySellEligible", isBuySellEligible);

  const handleMarketBuy = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    const accreditationResult = await checkCurrencyPairAccreditedStatus(localStorage.getItem("userId"), selectedCounter, selectedBase, 'BUY', onlyBuyAmount);

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setIsButtonDisabled(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doMarketBuy();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setIsButtonDisabled(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(1);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doMarketBuy = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    if (isBuySellEligible) {
      axios
        .get(`${TRADESERVICE}?symbol=${selectedCounter}${selectedBase}&side=BID&amount=${onlyBuyAmount}`)
        .then((response) => {
          const result = response.data;
          if (selectedBase.toLowerCase() === "usd") {
            setOnlyBuyPrice(parseFloat(result.price).toFixed(4));
            setOnlyBuyPrice1(parseFloat(result.price1));
          } else {
            setOnlyBuyPrice(parseFloat(result.price).toFixed(6));
            setOnlyBuyPrice1(parseFloat(result.price1));
          }
          const inputObj = {
            selling_asset_code: selectedBase.toUpperCase(),
            buying_asset_code: selectedCounter.toUpperCase(),
            userId: localStorage.getItem("user_id"),
            price: result.price1,
            txn_type: "1",
          };
          axios
            .post(WEBSERVICE + "/userTrade/OfferPriceCheck", inputObj, {
              headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
              const result = response.data;
              if (result.error.error_data != 0) {
                showToast("error", result.error.error_msg);
                setIsButtonDisabled(false);
                setIsLoading(false);
              } else {
                var assetCode = handleGetAssetCode(selectedCounter.toUpperCase(), selectedBase.toUpperCase());
                var baseCurrencyId = handleGetAssetId(selectedCounter.toUpperCase(), selectedBase.toUpperCase())["baseCurrencyId"];
                var currencyId = handleGetAssetId(selectedCounter.toUpperCase(), selectedBase.toUpperCase())["currencyId"];
                const tradeObj = {
                  selling_asset_code: selectedBase.toUpperCase(),
                  buying_asset_code: selectedCounter.toUpperCase(),
                  amount: parseFloat(onlyBuyAmount),
                  price: onlyBuyPrice1,
                  offerType: "M",
                  txn_type: "1",
                  assetCode: assetCode,
                  baseCurrencyId: baseCurrencyId,
                  currencyId: currencyId,
                  uuid: localStorage.getItem("uuid"),
                };
                axios
                  .post(WEBSERVICE + "userTrade/TradeCreateOffer", tradeObj, {
                    headers: {
                      "Content-Type": "application/json",
                      authorization: `BEARER ${localStorage.getItem("access_token")}`,
                    },
                  })
                  .then((data) => {
                    data = data.data;
                    setIsButtonDisabled(false);
                    setIsLoading(false);
                    showToast(data.error.error_data == 0 ? "success" : "error", data.error.error_msg);
                    reset();
                    renderUpdatedBalance("buy");
                    renderUpdatedBalance("sell");
                  });
              }
            });
        })
        .catch((error) => {
          setIsButtonDisabled(false);
          setIsLoading(false);
          showToast("error", "An error occurred while fetching data");
        });
    } else {
      const inputObj = {
        userId: localStorage.getItem("user_id"),
        baseCurrency: selectedBase.toUpperCase(),
        currency: selectedCounter.toUpperCase(),
        amount: parseFloat(onlyBuyAmount),
        action: "1",
      };
      axios
        .post(WEBSERVICE + "/home/currencyConversion", inputObj, {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        })
        .then((response) => {
          setIsLoading(false);
          showToast(
            response.data.error.error_data === 0 ? "success" : "error",
            response.data.error.error_msg
          );
          reset();
          renderUpdatedBalance("buy");
        })
        .catch(() => {
          setIsLoading(false);
          showToast("error", "An error occurred while converting currency");
        });
    }
  };

  const handleMarketSell = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    const accreditationResult = await checkCurrencyPairAccreditedStatus(localStorage.getItem("userId"), selectedCounter, selectedBase, 'SELL', onlySellAmount);

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setIsButtonDisabled(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doMarketSell();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setIsButtonDisabled(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(2);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doMarketSell = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    if (isBuySellEligible) {
      axios
        .get(`${TRADESERVICE}?symbol=${selectedCounter}${selectedBase}&side=ASK&amount=${onlySellAmount}`)
        .then((response) => {
          const result = response.data;
          var setOnlySellPriceBak = response.data;
          if (selectedBase.toLowerCase() === "usd") {
            setOnlySellPrice(parseFloat(result.price).toFixed(4));
            setOnlySellPrice1(parseFloat(result.price1));
          } else {
            setOnlySellPrice(parseFloat(result.price).toFixed(6));
            setOnlySellPrice1(parseFloat(result.price1));
          }
          const inputObj = {
            selling_asset_code: selectedCounter.toUpperCase(),
            buying_asset_code: selectedBase.toUpperCase(),
            userId: localStorage.getItem("user_id"),
            price: result.price1,
            txn_type: "2",
          };
          axios
            .post(WEBSERVICE + "/userTrade/OfferPriceCheck", inputObj, {
              headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
              const result = response.data;
              if (result.error.error_data != 0) {
                showToast("error", result.error.error_msg);
                setIsLoading(false);
                setIsButtonDisabled(false);
              } else {
                const assetCode = handleGetAssetCode(selectedCounter.toUpperCase(), selectedBase.toUpperCase());
                const baseCurrencyId = handleGetAssetId(selectedCounter.toUpperCase(), selectedBase.toUpperCase())["baseCurrencyId"];
                const currencyId = handleGetAssetId(selectedCounter.toUpperCase(), selectedBase.toUpperCase())["currencyId"];
                const tradeObj = {
                  selling_asset_code: selectedCounter.toUpperCase(),
                  buying_asset_code: selectedBase.toUpperCase(),
                  amount: parseFloat(onlySellAmount),
                  price: parseFloat(setOnlySellPriceBak.price1),
                  offerType: "M",
                  txn_type: "2",
                  assetCode: assetCode,
                  baseCurrencyId: baseCurrencyId,
                  currencyId: currencyId,
                  uuid: localStorage.getItem("uuid"),
                };
                axios
                  .post(WEBSERVICE + "/userTrade/TradeCreateOffer", tradeObj, {
                    headers: {
                      "Content-Type": "application/json",
                      authorization: `BEARER ${localStorage.getItem("access_token")}`,
                    },
                  })
                  .then((data) => {
                    setIsLoading(false);
                    setIsButtonDisabled(false);
                    const result = data.data;
                    showToast(result.error.error_data == 0 ? "success" : "error", result.error.error_msg);
                    reset();
                    renderUpdatedBalance("buy");
                    renderUpdatedBalance("sell");
                  });
              }
            })
            .catch(() => {
              setIsLoading(false);
              setIsButtonDisabled(false);
              showToast("error", "An error occurred while fetching data");
            });
        })
        .catch(() => {
          setIsLoading(false);
          setIsButtonDisabled(false);
          showToast("error", "An error occurred while fetching data");
        });
    } else {
      const inputObj = {
        userId: localStorage.getItem("user_id"),
        baseCurrency: selectedBase.toUpperCase(),
        currency: selectedCounter.toUpperCase(),
        amount: parseFloat(onlySellAmount),
        action: "2",
      };
      axios
        .post(WEBSERVICE + "/home/currencyConversion", inputObj, {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        })
        .then((data) => {
          setIsLoading(false);
          const result = data.data;
          showToast(result.error.error_data === 0 ? "success" : "error", result.error.error_msg);
          reset();
          renderUpdatedBalance("sell");
        })
        .catch(() => {
          setIsLoading(false);
          showToast("error", "An error occurred while converting currency");
        });
    }
  };

  const reset = () => {
    setOnlyBuyAmount("");
    setOnlyBuyUSD("");
    setOnlyBuyPrice("");
    setOnlyBuyTotalPrice("");
    setOnlySellAmount("");
    setOnlySellUSD("");
    setOnlySellPrice("");
    setOnlySellTotalPrice("");
  };

  const renderUpdatedBalance = (action) => {
    const userTransObj = {
      customerId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
    };
    axios
      .post(`${WEBSERVICE}transaction/getUserBalance`, JSON.stringify(userTransObj), {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        const result = response.data;
        if (result.error.error_data != 0) {
          showToast("error", "Cannot fetch user balance");
        } else {
          const balance = result.userBalanceList;
          for (let i = 0; i < balance.length; i++) {
            if (action === "buy") {
              if (balance[i].currencyCode === selectedBase.toUpperCase()) {
                setSelectedSellingAssetBalance(balance[i].closingBalance);
                break;
              }
            } else {
              if (balance[i].currencyCode === selectedCounter.toUpperCase()) {
                setSelectedBuyingAssetBalance(balance[i].closingBalance);
                break;
              }
            }
          }
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
          logout();
        }
      })
      .finally(() => setIsLoading(false));
  };

  const getBasecurrencyList = async () => {
    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getAllCurrency/${localStorage.getItem("BROKERID")}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setCounterCurrency(response.data.currencyList);
    } catch (error) {
      setErrorMessage(error.response ? `Error: ${error.response.status}` : "An unexpected error occurred");
    }
  };

  const getCounterCurrency = (currency) => {
    setSelectedBase("");
    setOnlyBuyAmount(""); setOnlyBuyUSD(""); setOnlyBuyPrice(""); setOnlyBuyTotalPrice("");
    setOnlySellAmount(""); setOnlySellUSD(""); setOnlySellPrice(""); setOnlySellTotalPrice("");
    const abcd = balanceList.filter((x) => x.currencyCode === currency);
    setSelectedBuyingAssetBalance(abcd.length > 0 ? abcd[0].closingBalance : 0);
    setSelectedCounter(currency);
    axios
      .get(
        `${WEBSERVICE}home/getBaseByCurrency?brokerId=${localStorage.getItem("BROKERID")}&currency=${currency}&country=${localStorage.getItem("userCountry")}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((response) => {
        setBaseCurrency(response.data.baseCurrencyList);
        setIsDisabled(false);
        fetchBalances();
      })
      .catch((error) => {
        setErrorMessage("Error fetching counter currency data.");
      });
  };

  const getBaseCurrency = (baseCurrency) => {
    setOnlyBuyAmount(""); setOnlyBuyUSD(""); setOnlyBuyPrice(""); setOnlyBuyTotalPrice("");
    setOnlySellAmount(""); setOnlySellUSD(""); setOnlySellPrice(""); setOnlySellTotalPrice("");
    const abcde = balanceList.filter((x) => x.currencyCode === baseCurrency);
    if (abcde.length > 0) setSelectedSellingAssetBalance(abcde[0].closingBalance);
    setSelectedBase(baseCurrency);
    getPairWiseBuySellCheck(selectedCounter, baseCurrency, actionType);
  };

  const getPairWiseBuySellCheck = async (currency, baseCurrency, action) => {
    setIsLoading(true);
    const pairWiseResponse = await axios.get(
      `${WEBSERVICE}home/pairWiseBuySellChecking?currency=${currency}&baseCurrency=${baseCurrency}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      }
    );
    if (pairWiseResponse.data.error.error_data !== 0) {
      showToast("error", pairWiseResponse.data.error.error_msg);
      return;
    }
    if (pairWiseResponse.data.buySellFlag === 0) {
      setIsBuySellEligible(false);
      const payload = { currency, baseCurrency, action };
      const marketPriceResponse = await axios.post(
        `${WEBSERVICE}home/marketPrice`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (marketPriceResponse.data.error.error_data !== 0) {
        showToast("error", marketPriceResponse.data.error.error_msg);
        setIsLoading(false);
        return;
      }
      const mp = parseFloat(marketPriceResponse.data.marketPrice);
      const precision = getSpecificAssetPairPrecision(`${selectedCounter}${baseCurrency}`).pricePrecision;
      if (action === 1) {
        setOnlyBuyPrice(mp.toFixed(precision));
        setOnlyBuyAmount(1);
        setOnlyBuyTotalPrice((mp * 1).toFixed(precision));
        setMarketPrice(mp);
      } else {
        setOnlySellPrice(mp.toFixed(precision));
        setOnlySellAmount(1);
        setOnlySellTotalPrice((mp * 1).toFixed(precision));
      }
    } else {
      setIsBuySellEligible(true);
    }
    setIsLoading(false);
  };

  const getCounterCurrencyForSell = async (currency) => {
    setSelectedBase("");
    setOnlyBuyAmount(""); setOnlyBuyUSD(""); setOnlyBuyPrice(""); setOnlyBuyTotalPrice("");
    setOnlySellAmount(""); setOnlySellUSD(""); setOnlySellPrice(""); setOnlySellTotalPrice("");
    const selectedCurrency = balanceList.filter((x) => x.currencyCode === currency);
    if (selectedCurrency.length > 0) setSelectedBuyingAssetBalance(selectedCurrency[0].closingBalance);
    setSelectedCounter(currency);
    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getBaseByCurrency?brokerId=${localStorage.getItem("BROKERID")}&currency=${currency}&country=${localStorage.getItem("userCountry")}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
        return;
      }
      setBaseCurrency(response.data.baseCurrencyList);
      setIsDisabled(false);
    } catch (error) {
      setIsLoading(false);
      if (error.response?.status === 401) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        logout();
      } else {
        showToast("error", "An error occurred. Please try again later.");
      }
    }
  };

  const handleBuyAmountChange = async (value) => {
    setOnlyBuyAmount(value);
    setIsSellError(false); setIsSellErrorDepth(false); setIsBuyError(false); setIsBuyErrorDepth(false);
    if (!value || value <= 0) { setOnlyBuyUSD(""); return; }
    const rate = await getUSDToCryptoRate(selectedCounter);
    setOnlyBuyUSD((parseFloat(value) * rate).toFixed(6));
    processBuyCalculation(value);
  };

  const handleBuyUSDAmountChange = async (value) => {
    setOnlyBuyUSD(value);
    setIsSellError(false); setIsSellErrorDepth(false); setIsBuyError(false); setIsBuyErrorDepth(false);
    if (!value || value <= 0) { setOnlyBuyAmount(""); return; }
    const rate = await getUSDToCryptoRate(selectedCounter);
    const cryptoAmount = (parseFloat(value) * rate).toFixed(8);
    setOnlyBuyAmount(cryptoAmount);
    processBuyCalculation(cryptoAmount);
  };

  const handleSellAmountChange = async (value) => {
    setOnlySellAmount(value);
    setIsSellError(false); setIsSellErrorDepth(false); setIsBuyError(false); setIsBuyErrorDepth(false);
    if (!value || value <= 0) { setOnlySellUSD(""); return; }
    const rate = await getUSDToCryptoRate(selectedCounter);
    setOnlySellUSD((parseFloat(value) * rate).toFixed(6));
    processSellCalculation(value);
  };

  const handleSellUSDAmountChange = async (value) => {
    setOnlySellUSD(value);
    setIsSellError(false); setIsSellErrorDepth(false); setIsBuyError(false); setIsBuyErrorDepth(false);
    if (!value || value <= 0) { setOnlySellAmount(""); return; }
    const rate = await getUSDToCryptoRate(selectedCounter);
    const cryptoAmount = (parseFloat(value) * rate).toFixed(8);
    setOnlySellAmount(cryptoAmount);
    processSellCalculation(cryptoAmount);
  };

  const getUSDToCryptoRate = async (symbol) => {
    try {
      const response = await axios.post(
        `${WEBSERVICE}home/marketPrice`,
        { currency: symbol, baseCurrency: "USD", action: 1 },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      return response?.data?.marketPrice;
    } catch (err) {
      return 0;
    }
  };

  const processBuyCalculation = (val) => {
    if (isBuySellEligible) {
      axios
        .get(`${TRADESERVICE}?symbol=${selectedCounter}${selectedBase}&side=BID&amount=${val}`)
        .then((response) => {
          const result = response.data;
          if (result.statuscode !== "0") {
            const price = parseFloat(result.price).toFixed(6);
            setOnlyBuyPrice(price);
            const total = (price * val).toFixed(6);
            setOnlyBuyTotalPrice(total);
            setIsBuyError(total < 0.001);
          } else {
            setOnlyBuyPrice(0); setOnlyBuyTotalPrice(0); setIsBuyErrorDepth(true);
          }
        })
        .catch(handleApiError);
    } else {
      fallbackMarketCalculation(val);
    }
  };

  const processSellCalculation = (val) => {
    if (isBuySellEligible) {
      axios
        .get(`${TRADESERVICE}?symbol=${selectedCounter}${selectedBase}&side=ASK&amount=${val}`)
        .then((response) => {
          const result = response.data;
          if (result.statuscode != "0") {
            if (selectedSellingAssetText.toUpperCase() === "USD") {
              setOnlySellPrice(parseFloat(result.price).toFixed(4));
              const total = (parseFloat(result.price) * parseFloat(val)).toFixed(4);
              setOnlySellTotalPrice(total);
              setIsSellError(total < 0.001);
            } else {
              setOnlySellPrice(parseFloat(result.price).toFixed(6));
              const total = (parseFloat(result.price) * parseFloat(val)).toFixed(6);
              setOnlySellTotalPrice(total);
              setIsSellError(total < 0.001);
            }
          } else {
            setOnlySellPrice(0); setOnlySellTotalPrice(0); setIsSellErrorDepth(true);
          }
        })
        .catch((error) => {
          if (error.response?.status === 401) { showToast("error", "SESSION TIMED OUT. LOGIN AGAIN"); logout(); }
        });
    } else {
      if (selectedSellingAssetText === "usd") {
        setOnlySellPrice(parseFloat(onlySellPrice).toFixed(4));
        const total = (parseFloat(onlySellPrice) * parseFloat(val)).toFixed(4);
        setOnlySellTotalPrice(total);
        setIsSellError(total < 0.001);
      } else {
        axios
          .post(`${WEBSERVICE}home/marketPrice`, { currency: selectedCounter, baseCurrency: selectedBase, action: 2 }, {
            headers: { "Content-Type": "application/json", authorization: `BEARER ${localStorage.getItem("access_token")}` },
          })
          .then((response) => {
            if (response.data.error.error_data !== 0) {
              showToast("error", response.data.error.error_msg);
            } else {
              setOnlySellPrice(response.data.marketPrice);
              const total = (parseFloat(response.data.marketPrice) * parseFloat(val)).toFixed(6);
              setOnlySellTotalPrice(total);
              setIsSellError(total < 0.001);
            }
          })
          .catch((error) => {
            if (error.response?.status === 401) { showToast("error", "SESSION TIMED OUT. LOGIN AGAIN"); logout(); }
          });
      }
    }
  };

  const fallbackMarketCalculation = (val) => {
    if (selectedSellingAssetText?.toUpperCase() === "USD") {
      const price = parseFloat(marketPrice).toFixed(6);
      setOnlyBuyPrice(price);
      const total = (price * parseFloat(val)).toFixed(6);
      setOnlyBuyTotalPrice(total);
      setIsBuyError(total < 0.001);
    } else {
      axios
        .post(`${WEBSERVICE}home/marketPrice`, { currency: selectedCounter, baseCurrency: selectedBase, action: actionType }, {
          headers: { "Content-Type": "application/json", authorization: `BEARER ${localStorage.getItem("access_token")}` },
        })
        .then((response) => {
          if (response.data.error.error_data !== 0) {
            showToast("error", response.data.error.error_msg);
          } else {
            const price = parseFloat(response.data.marketPrice).toFixed(6);
            setOnlyBuyPrice(price);
            const total = (price * parseFloat(val)).toFixed(6);
            setOnlyBuyTotalPrice(total);
            setIsBuyError(total < 0.001);
          }
        })
        .catch(handleApiError);
    }
  };

  const handleApiError = (error) => {
    if (error.response?.status === 401) { showToast("error", "SESSION TIMED OUT. LOGIN AGAIN"); logout(); }
    else showToast("error", "Something went wrong. Try again.");
  };

  const getSpecificAssetPairPrecision = (pair) => ({ pricePrecision: 4 });

  const fetchFees = async () => {
    try {
      const response = await axios.get("/api/fees");
      setFees(response.data);
    } catch (error) {
      console.error("Error fetching fees:", error);
    }
  };

  const setActionAndTextType = (val) => {
    // val is the Tabs index (0 = Buy tab, 1 = Sell tab); the API expects action 1 = Buy, 2 = Sell.
    setActionType(val === 0 ? 1 : 2);
    if (val === 0) {
      setButtonType("Buy");
      setButtonTypeSmall("buy");
      setAccountType("Buying");
    } else {
      setButtonType("Sell");
      setButtonTypeSmall("sell");
      setAccountType("Selling");
    }
  };

  // ── Derived ─────────────────────────────────────────────────────────────────
  const isBuy = actionType === 1 || actionType === 0 && buttonType === "Buy" || buttonType === "Buy";
  const activeTabIndex = buttonType === "Buy" ? 0 : 1;

  const showBalance =
    selectedSellingAssetBalance && selectedCounter !== "Select Currency";

  const instructions = [
    `Select the crypto you want to ${buttonTypeSmall}.`,
    `Select the crypto / fiat you want to sell in order to buy.`,
    `Enter the amount next to "${accountType} Amount".`,
    `Review the price that auto-populates.`,
    `Review the total trade cost next to "Total Price".`,
    `Click "${buttonType}" to execute the transaction.`,
  ];

  // ── Render ───────────────────────────────────────────────────────────────────
  return (
    <Box sx={pageWrapper}>

      {/* ── Hero Banner ── */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.72)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <SyncAltOutlinedIcon sx={{ color: "#fff", fontSize: 28 }} />
          </Box>
          <Box>
            <Typography sx={heroTitle}>Convert Market</Typography>
            <Typography sx={heroSubtitle}>
              Change one crypto to another instantly at market price
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Main Card ── */}
      <Box sx={mainCard}>

        {/* Tabs + Fees */}
        <Box sx={tabsWrap}>
          <Tabs
            value={activeTabIndex}
            onChange={(_, v) => setActionAndTextType(v)}
            sx={{
              ...tabsStyle,
              "& .MuiTabs-indicator": {
                backgroundColor: v => v === 0 ? "#16a34a" : "#ef4444",
                height: 3,
                borderRadius: "3px 3px 0 0",
              },
              "& .MuiTabs-indicator": {
                backgroundColor: activeTabIndex === 0 ? "#16a34a" : "#ef4444",
                height: 3,
                borderRadius: "3px 3px 0 0",
              },
            }}
          >
            <Tab
              iconPosition="start"
              icon={<TrendingUpOutlinedIcon sx={{ fontSize: 18 }} />}
              label="Buy"
              sx={{
                ...tabItem,
                "&.Mui-selected": { color: "#16a34a", opacity: 1 },
              }}
            />
            <Tab
              iconPosition="start"
              icon={<TrendingDownOutlinedIcon sx={{ fontSize: 18 }} />}
              label="Sell"
              sx={{
                ...tabItem,
                "&.Mui-selected": { color: "#ef4444", opacity: 1 },
              }}
            />
          </Tabs>

          {/* Fees button aligned right */}
          <Box sx={{ display: "flex", alignItems: "center", pr: 2 }}>
            <ContainedButton
              variant="contained"
              size="small"
              onClick={() => setModalOpen(true)}
              sx={{ height: 32, px: 2, borderRadius: "8px", textTransform: "none", fontWeight: 600, fontSize: "0.78rem" }}
            >
              View Fees
            </ContainedButton>
          </Box>
        </Box>

        <Box sx={tabPanel}>

          {/* ── Instructions strip ── */}
          <Box sx={instructionsWrap}>
            {instructions.map((text, i) => (
              <Box key={i} sx={instrItem}>
                <Box sx={{ ...instrNum, backgroundColor: alpha(btncolor || "#1976d2", 0.12), color: btncolor }}>
                  {i + 1}
                </Box>
                <Typography sx={instrText}>{text}</Typography>
              </Box>
            ))}
          </Box>

          {/* ── Currency pair selectors ── */}
          <Box sx={pairRow}>
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>
                {buttonType === "Buy" ? "Buy" : "Sell"}
              </Typography>
              <TextField
                select
                value={selectedCounter}
                onChange={(e) =>
                  buttonType === "Buy"
                    ? getCounterCurrency(e.target.value)
                    : getCounterCurrencyForSell(e.target.value)
                }
                sx={modernFieldStyle}
                fullWidth
              >
                <MenuItem value="">Select Currency</MenuItem>
                {counterCurrency.map((item, index) => (
                  <MenuItem key={index} value={item}>{item}</MenuItem>
                ))}
              </TextField>
            </Box>

            <Box sx={pairDivider}>
              <SyncAltOutlinedIcon sx={{ fontSize: 20, opacity: 0.35 }} />
            </Box>

            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>
                {buttonType === "Buy" ? "With" : "For"}
              </Typography>
              <TextField
                select
                value={selectedBase}
                disabled={isDisabled}
                onChange={(e) => getBaseCurrency(e.target.value)}
                sx={modernFieldStyle}
                fullWidth
              >
                <MenuItem value="">Select Currency</MenuItem>
                {baseCurrency.map((item, index) => (
                  <MenuItem key={index} value={item}>{item}</MenuItem>
                ))}
              </TextField>
            </Box>

            {/* Balance (right side) */}
            {showBalance && (
              <Box sx={balanceBlock}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                  <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 14, opacity: 0.5 }} />
                  <Typography sx={balanceLabel}>Balance</Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                  <Typography sx={balanceValue}>
                    {buttonType === "Buy" ? selectedSellingAssetBalance : selectedBuyingAssetBalance}
                    {" "}
                    <span style={{ opacity: 0.55, fontWeight: 400, fontSize: "0.75rem" }}>
                      {buttonType === "Buy" ? selectedBase : selectedCounter}
                    </span>
                  </Typography>
                  <Tooltip title="Go to Wallet">
                    <Link to="/my-wallet" className="no-underline" style={{ lineHeight: 0 }}>
                      <img src={sendIconCore} width={16} style={{ opacity: 0.6 }} alt="wallet" />
                    </Link>
                  </Tooltip>
                </Box>
              </Box>
            )}
          </Box>

          {/* ── Amount / Price / Total fields ── */}
          <Box sx={fieldsGrid}>

            {/* Amount */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>
                {buttonType === "Buy" ? "Buying Amount" : "Selling Amount"}
              </Typography>
              <TextField
                type="text"
                value={buttonType === "Buy" ? (!swapBuy ? onlyBuyAmount : onlyBuyUSD) : (!swapSell ? onlySellAmount : onlySellUSD)}
                onChange={(e) => {
                  if (buttonType === "Buy") {
                    !swapBuy ? handleBuyAmountChange(e.target.value) : handleBuyUSDAmountChange(e.target.value);
                  } else {
                    !swapSell ? handleSellAmountChange(e.target.value) : handleSellUSDAmountChange(e.target.value);
                  }
                }}
                disabled={selectedBase === ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={adornText}>
                        {buttonType === "Buy"
                          ? (!swapBuy ? selectedCounter : "USD")
                          : (!swapSell ? selectedCounter : "USD")}
                      </Typography>
                    </InputAdornment>
                  ),
                }}
                sx={modernFieldStyle}
                fullWidth
              />
              {/* Swap toggle */}
              {((buttonType === "Buy" && selectedCounter && onlyBuyAmount) ||
                (buttonType === "Sell" && selectedCounter && onlySellAmount)) && (
                <Box
                  sx={swapToggle}
                  onClick={buttonType === "Buy" ? handleSwapBuy : handleSwapSell}
                >
                  <SwapVertIcon sx={{ fontSize: 13 }} />
                  <Typography sx={swapToggleText}>
                    {buttonType === "Buy"
                      ? `${swapBuy ? selectedCounter : "USD"}: ${swapBuy ? onlyBuyAmount : onlyBuyUSD}`
                      : `${swapSell ? selectedCounter : "USD"}: ${swapSell ? onlySellAmount : onlySellUSD}`}
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Price */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>Price</Typography>
              <TextField
                type="text"
                value={buttonType === "Buy" ? onlyBuyPrice : onlySellPrice}
                readOnly
                disabled
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={adornText}>{selectedBase}</Typography>
                    </InputAdornment>
                  ),
                }}
                sx={modernFieldStyle}
                fullWidth
              />
            </Box>

            {/* Total Price */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>Total Price</Typography>
              <TextField
                type="text"
                value={buttonType === "Buy" ? onlyBuyTotalPrice : onlySellTotalPrice}
                readOnly
                disabled
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={adornText}>{selectedBase}</Typography>
                    </InputAdornment>
                  ),
                }}
                sx={modernFieldStyle}
                fullWidth
              />
            </Box>
          </Box>

          {/* ── Errors ── */}
          {(buttonType === "Buy" ? isBuyErrorDepth : isSellErrorDepth) && (
            <Typography sx={errorText}>Orderbook depth reached — price not found</Typography>
          )}
          {(buttonType === "Buy" ? isBuyError : isSellError) && (
            <Typography sx={errorText}>Total price must be at least 0.001</Typography>
          )}

          {/* ── Action button ── */}
          <Box sx={actionRow}>
            <ContainedButton
              variant="contained"
              size="large"
              disabled={
                buttonType === "Buy"
                  ? !(onlyBuyAmount > 0) || isBuyError || isBuyErrorDepth
                  : !(onlySellAmount > 0) || isSellError || isSellErrorDepth
              }
              onClick={buttonType === "Buy" ? handleMarketBuy : handleMarketSell}
              sx={{
                ...actionBtn,
                backgroundColor: buttonType === "Buy" ? "#16a34a" : "#ef4444",
                "&:hover": { backgroundColor: buttonType === "Buy" ? "#15803d" : "#dc2626" },
                "&.Mui-disabled": {
                  color: "#fff",
                  backgroundColor: buttonType === "Buy" ? "#16a34a" : "#ef4444",
                  opacity: 0.5,
                },
              }}
              endIcon={isLoading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
            >
              {buttonType}
            </ContainedButton>
          </Box>

        </Box>
      </Box>

      <FeeModal open={modalOpen} onClose={() => setModalOpen(false)} />
      <AccreditationVerificationPopup
        open={showAccreditedPopup}
        onClose={() => setShowAccreditedPopup(false)}
        theme={theme}
      />
      <TermsAgreementPopup
        open={showTermsPopup}
        onClose={() => {
          setShowTermsPopup(false);
          setPendingProceed(null);
        }}
        onProceed={() => {
          if (typeof pendingProceed === "function") {
            pendingProceed();
          }
          setPendingProceed(null);
        }}
        links={termsLinks}
        theme={theme}
        vestingCurrency={selectedCounter}
        txnType={pendingTxnType}
      />
    </Box>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 540,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const tabsWrap = {
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  px: { xs: 1, md: 2 },
  backgroundColor: "var(--body-color-less2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const tabsStyle = {
  minHeight: 56,
  "& .MuiTab-root": { minHeight: 56 },
};

const tabItem = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  color: "var(--text-color)",
  opacity: 0.65,
  letterSpacing: "0.01em",
  px: 2,
  gap: 0.75,
};

const tabPanel = {
  p: { xs: 2, md: 3 },
};

// Instructions
const instructionsWrap = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
  gap: 1,
  mb: 3,
  pb: 3,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
};

const instrItem = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1,
};

const instrNum = {
  width: 20,
  height: 20,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "0.65rem",
  fontWeight: 800,
  flexShrink: 0,
  mt: "1px",
};

const instrText = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.65,
  lineHeight: 1.55,
};

// Currency pair row
const pairRow = {
  display: "flex",
  alignItems: "flex-end",
  gap: 1.5,
  mb: 2.5,
  flexWrap: "wrap",
};

const pairDivider = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pb: "4px",
  flexShrink: 0,
};

const balanceBlock = {
  ml: "auto",
  textAlign: "right",
  flexShrink: 0,
};

const balanceLabel = {
  fontSize: "0.65rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  color: "var(--text-color)",
  opacity: 0.45,
};

const balanceValue = {
  fontSize: "0.9rem",
  fontWeight: 700,
  color: "var(--text-color)",
};

// Fields
const fieldsGrid = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
  gap: 2,
  mb: 2,
};

const fieldWrap = {
  display: "flex",
  flexDirection: "column",
  gap: 0.75,
  minWidth: 0,
};

const fieldLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.55,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

const modernFieldStyle = {
  "& .MuiInputBase-root": {
    height: "48px",
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "0.9rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiSelect-select": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.25)" },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.45)" },
  "& .MuiInputLabel-root": { display: "none" },
  "& legend": { display: "none" },
  "& fieldset": { top: 0 },
  "& .MuiInputBase-input.Mui-disabled": { color: "var(--text-color)", WebkitTextFillColor: "var(--text-color)", opacity: 0.5 },
};

const adornText = {
  fontSize: "0.75rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.5,
  userSelect: "none",
};

// Swap toggle link
const swapToggle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.4,
  mt: 0.5,
  cursor: "pointer",
  opacity: 0.6,
  "&:hover": { opacity: 1 },
};

const swapToggleText = {
  fontSize: "0.72rem",
  color: "var(--text-color)",
  lineHeight: 1,
};

// Error
const errorText = {
  fontSize: "0.78rem",
  color: "#ef4444",
  mb: 1.5,
  fontWeight: 500,
};

// Action
const actionRow = {
  mt: 2,
};

const actionBtn = {
  height: 48,
  px: 4,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 700,
  fontSize: "0.95rem",
  letterSpacing: "0.02em",
  minWidth: 120,
  color: "#fff",
};

export default ConvertComponent;
